import React, { useRef } from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import { convertDateFormat } from "../../Utils/utils";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import SliderNavigation from "../SliderNavigation";

const Publication = () => {
  const { getText } = useLanguageTranslation();
  const navigate = useNavigate();
  const slider = useRef();
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: publicationsData = [], isLoading: publicationsIsLoading } =
    useGetProtectedApiDataQuery({ url: "publication", lang: languageType });

  const next = () => {
    slider.current.slickNext();
  };
  const prev = () => {
    slider.current.slickPrev();
  };
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    pauseOnHover: true,
    customPaging: (i) => (
      <button>
        <span className="dot" />
      </button>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  if (publicationsIsLoading) {
    return (
      <div className="photo-loader sec-loader">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <div className="tab-pane active" id="photos">
      <div className="publications-sec">
        <Slider {...settings} ref={slider}>
          {publicationsData.map((item, index) => (
            <div className="publicationslist">
              <div className="card-sec" key={index}>
                <div className="img-sec">
                  <a
                    href={`${process.env.REACT_APP_IMAGE_URL}/${item?.field_covid_document}`}
                    target="_blank" rel="noopener noreferrer"
                  >
                    <img
                      src={`${process.env.REACT_APP_IMAGE_URL}/${item?.nothing}`}
                      alt={item.title}
                    />
                  </a>
                </div>
                <div className="pdf-link">
                  <img
                    src="./images/pdf-icon.png"
                    alt="/pdf-icon"
                    className="mr-2"
                  />
                </div>
                <div className="desc-sec">
                  <div>
                    <span className="date">
                      {convertDateFormat(item?.field_date_of_publication)}
                    </span>
                    {item?.field_publication_vol && (
                      <span className="vol-txt">
                        {item.field_publication_vol}
                      </span>
                    )}
                  </div>
                  <p className="line-clamp line-clamp-2">{item.title}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="flex-box">
        <div className="btn-sec">
          <SliderNavigation slider={slider} section={"publications"} />

          <a
            href="#"
            className="quick-btn"
            onClick={(e) => {
              e.preventDefault();
              navigate("/publication-detail");
            }}
            aria-label={"View All Publication"}
          >
            {getText("View All", "सभी देखें")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Publication;
